import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import useModal, { MODAL_LG, MODAL_md } from '../../../theme/Component/hooks/useModal';
import { _InventoryCatalogByMarke } from '../../../../core/services/dataBean/EntityCatalogVdos';
import { Modal } from '../../../theme/Component/Modal';
import { BasicTable, MASK_BOOLEAN_ICON, MASK_MONEY, MASK_NUMBER } from '../../../theme/Component/BasicTable';
import usePaginator from '../../../theme/Component/usePaginator';
import { MarketPlaceCategoryEditor } from '../MarketPlace/MarketPlaceCategoryEditor';
import { SelectProductEditor } from '../../../Factoty&Production/ManufacturingStandars/Components/SelectProductEditor';
import { BasicButton } from '../../../theme/Component/BasicButton';


interface Props {
    idMarketPlace: any;
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const InventoryCatalogByMarketEditor = ({ idSelector, onChange, label, returnType = "ID", render, idMarketPlace }: Props) => {

    const { instance, lista, setLista } = useDataBean(_InventoryCatalogByMarke)
    const [MarketPlaceCategory, setMarketPlaceCategory] = useState<any>(null);
    const [regexStr, setregexStr] = useState<any>(null);
    const [productCode, setProductCode] = useState<any>(null);
    const [reference, setReference] = useState<any>(null);
    const [IDProduct, setIDProduct] = useState<any>(null);
    const [id, setID] = useState(null);
    const paginador = usePaginator();
    const modal = useModal("Producto Market Place", MODAL_LG);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDMarketPlaceProduct == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };


    useEffect(() => {
        getLista();
    }, [idMarketPlace, paginador.page])

    const getLista = () => {

        instance.getInventoryCatalogByMarketPlaceAndPriceList(idMarketPlace, 1, MarketPlaceCategory, null, regexStr, null, productCode, reference, IDProduct, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)
                }
            }
        )

    }
    const head = [
        { title: 'ID Producto en MarketPlace', property: 'IDMarketPlaceProduct', visible: true },
        { title: 'ID Lista de Precios del MarketPlace', property: 'IDPriceListItem', visible: true },
        { title: 'Identificador de Almacen', property: 'PriceListItemIDStore', visible: true },
        { title: 'Precio de Venta en MarketPlace', property: 'PriceValue', visible: true },
        { title: 'Identificador de Moneda', property: 'IDCurrency', visible: true },
        { title: 'Tipo de Precio', property: 'ProductValueTypeName', visible: true },
        { title: 'Incluye Impuestos', property: 'PriceListItemApplyTaxes', visible: true },
        { title: 'Codigo de Moneda', property: 'CurrencyCode', visible: true },
        { title: 'Nombre de Moneda', property: 'CurrencyName', visible: true },
    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Producto Market Place"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-4">
                        <MarketPlaceCategoryEditor idMarketPlace={idMarketPlace} idSelector={MarketPlaceCategory} onChange={(e) => { setMarketPlaceCategory(e) }} />
                    </div>
                    <div className="col-md-4">
                        <label>Búsqueda por Texto</label>
                        <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                    </div>
                    <div className="col-md-4">
                        <label>Código de Producto</label>
                        <input type="text" className="form-control" value={productCode} onChange={(e) => { setProductCode(e.target.value) }} />
                    </div>
                    <div className="col-md-4">
                        <label>Referencia de Producto</label>
                        <input type="text" className="form-control" value={reference} onChange={(e) => { setReference(e.target.value) }} />
                    </div>
                    <div className="col-md-4">
                        <SelectProductEditor value={IDProduct} onChange={(e) => { setIDProduct(e.IDProduct) }} label="Producto" />
                    </div>
                    <div className="col-md-4 mt-4 p-2">
                        <BasicButton icon="ri-file-search-line" clase="btn btn-primary" eventClick={getLista}>
                            Consultar
                        </BasicButton>
                    </div>
                </div>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDMarketPlaceProduct); modal.close(); }} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
            </Modal>
        </>
    )
}